<script lang="ts">
  import { Router, Route, navigate } from 'svelte-navigator';

  // Check for campaign code in URL query parameters
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    if (code) {
      console.log('Campaign code received:', code);
      localStorage.setItem('campaign_code', code);
      navigate('/step/1' + window.location.search, { replace: true });
    }
  }

  import Header from './components/header.svelte';
  import New from './components/admin/new.svelte';

  import SideBar from './components/side-bar.svelte';

  import Toasts from './components/_shared/toasts.svelte';
  import Welcome from './components/welcome/welcome.svelte';
  import Paid from './components/admin/paid.svelte';
  import AdminSideBar from './components/admin/admin-side-bar.svelte';
  import Footer from './components/_shared/footer.svelte';
  import Auth from './components/auth/auth.svelte';
  import RegistrationIsOver from './components/registration-is-over/registration-is-over.svelte';
  import PreApproved from './components/admin/pre-approved.svelte';
  import Verification from './components/admin/verification.svelte';
  import ParkingLot from './components/admin/parking-lot.svelte';
  import Approved from './components/admin/approved.svelte';
  import Rejected from './components/admin/rejected.svelte';
  import Incomplete from './components/admin/incomplete.svelte';
  import PrePayment from './components/admin/pre-payment.svelte';
  import RegistrationNotYetStarted from './components/registration-not-yet-started/registration-not-yet-started.svelte';
  import Personalinformation from './components/admin/personalinformation.svelte';
  import Errorboundery from './components/_shared/errorboundery.svelte';
  import Report from './components/admin/report.svelte';
  import ReciptsWithoutDealerId from './components/admin/paybacks-without-dealerId.svelte';
import AiChat from './routes/admin/ai-chat.svelte';

  import Compare from './components/admin/compare.svelte';
  import CompareSimple from './components/admin/compare-simple.svelte';
  import DealershipReport from './components/admin/dealership-report.svelte';

  import PurchaseReciptsBackup from './components/admin/purchase-recipts-backup.svelte';
  import Parts from './components/admin/parts.svelte';
  import Dealerships from './components/admin/dealerships.svelte';
  import VinAllowlist from './components/admin/vin-allowlist.svelte';
  import { debugLog } from './lib/debug-log';

  import ServiceInvoice from './components/processSteps/service-invoice/service-invoice.svelte';
  import PurchaseInformation from './components/processSteps/purchase-information/purchase-information.svelte';
  import PersonalInformation from './components/processSteps/personal-information/personal-information.svelte';
  import Questions from './components/processSteps/questions/questions.svelte';
  import TermsAndPrivacy from './components/processSteps/terms/terms-and-privacy.svelte';
  import AiChatWidget from './components/admin/ai-chat-widget.svelte';


  // read recognizedText from localstorage
  // const result = JSON.parse(localStorage.getItem("recognizedText") || "{}");

  // debugLog({ result });

  // const url = new URL(window.location.href);

  // const debugMode = url.searchParams.get("debug") === "true";

  // Check for JWT token instead of simple auth flag
  let authed: boolean = false;

  // Function to check if user is authenticated
  const checkAuth = () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        // Basic check for token existence and format
        // In a real app, you might want to validate the token's expiration
        const payload = JSON.parse(atob(token.split('.')[1]));

        debugLog({ payload });
        const currentTime = Date.now() / 1000;

        // Check if token is expired
        if (payload.exp && payload.exp > currentTime) {
          authed = true;
        } else {
          // Token expired, remove it
          localStorage.removeItem('token');
          authed = false;
        }
      } catch (e) {
        // Invalid token format, remove it
        localStorage.removeItem('token');
        authed = false;
      }
    } else {
      authed = false;
    }
  };

  // Check auth on component initialization
  checkAuth();

  // Listen for storage changes (token updates)
  if (typeof window !== 'undefined') {
    window.addEventListener('storage', checkAuth);

    // Also listen for storage events on the same window (when token is set by login component)
    window.addEventListener('storage', (e) => {
      if (e.key === 'token') {
        checkAuth();
      }
    });

    // Check periodically for token changes (fallback in case storage events don't fire)
    setInterval(checkAuth, 1000);
  }

  let isAppActive = false;
  let isStartingInFuture: boolean = false;

  try {
    const appStartDate = new Date(process.env.SVELTE_APP_APP_START_DATE!);
    const appEndDate = new Date(process.env.SVELTE_APP_APP_END_DATE!);
    const now = new Date();
    // isAppActive = now >= appStartDate && now <= appEndDate;
    isAppActive = true;
  } catch (e) {
    isAppActive = true;
  }

  try {
    const appStartDate = new Date(process.env.SVELTE_APP_APP_START_DATE!);
    const appEndDate = new Date(process.env.SVELTE_APP_APP_END_DATE!);
    const now = new Date();
    isStartingInFuture = now < appStartDate;
  } catch (e) {
    isStartingInFuture = false;
  }

  let webSiteId = process.env.SVELTE_APP_WEB_SITE_ID;
  debugLog('webSiteId is:' + webSiteId, process.env.NODE_ENV);
</script>

<svelte:head>
  {#if window.location.href.includes('localhost')}
    <script
      async
      defer
      data-website-id="7184d8d9-317f-4d87-b988-ba29b55a94c5"
      src="https://eu.umami.is/script.js"
    ></script>
  {:else if window.location.href.includes('nop')}
    <script
      async
      defer
      data-website-id="7184d8d9-317f-4d87-b988-ba29b55a94c5"
      src="https://eu.umami.is/script.js"
    ></script>
  {:else if window.location.href.includes('dev')}
    <script
      async
      defer
      data-website-id="7184d8d9-317f-4d87-b988-ba29b55a94c5"
      src="https://eu.umami.is/script.js"
    ></script>
  {:else if window.location.href.includes('uat')}
    <script
      async
      defer
      data-website-id="7184d8d9-317f-4d87-b988-ba29b55a94c5"
      src="https://eu.umami.is/script.js"
    ></script>
  {:else}
    <script
      async
      defer
      data-website-id={webSiteId}
      src="https://eu.umami.is/script.js"
    ></script>
  {/if}
</svelte:head>

<svelte:window
  on:load={() => {
    if (!('umami' in window)) {
      window['umami'] = {
        track: () => null,
        identify: () => null,
      };
    }
  }}
/>

<Toasts />
{#if window.location.href.includes('admin') && authed}
  <AiChatWidget />
{/if}

<Router primary={false}>
  {#if window.location.href.includes('admin')}
    {#if !authed}
      <Auth />
    {:else}
      <div class="flex">
        <div class="flex-shrink-0">
          <AdminSideBar />
        </div>
        <div class="flex-1 p-4 pb-16 md:p-6">
          <Route path="/admin/new" component={New} />
          <Route path="/admin/pre-approved" component={PreApproved} />
          <Route path="/admin/verification" component={Verification} />
          <Route path="/admin/parking-lot" component={ParkingLot} />
          <Route path="/admin/approved" component={Approved} />
          <Route path="/admin/pre-payment" component={PrePayment} />
          <Route path="/admin/paid" component={Paid} />
          <Route path="/admin/rejected" component={Rejected} />
          <Route path="/admin/incomplete" component={Incomplete} />
          <Route
            path="/admin/personalinformation"
            component={Personalinformation}
          />
          <Route path="/admin/report" component={Report} />
          <Route
            path="/admin/recipts-without-dealerId"
            component={ReciptsWithoutDealerId}
          />
          <Route path="/admin/compare" component={Compare} />
          <Route path="/admin/compare-simple" component={CompareSimple} />
          <Route path="/admin/dealership-report" component={DealershipReport} />

          <Route
            path="/admin/purchase-recipts-backup"
            component={PurchaseReciptsBackup}
          />
          <Route path="/admin/parts" component={Parts} />
          <Route path="/admin/dealerships" component={Dealerships} />
          <Route path="/admin/vin-allowlist" component={VinAllowlist} />
        </div>
      </div>
    {/if}
  {:else}
    <div class="flex min-h-screen flex-col">
      <Header {isStartingInFuture} {isAppActive} />
      <main class="flex-1 pb-6 sm:pb-8">
        <div
          class="mx-auto flex w-full flex-col gap-8 py-8 px-4 sm:px-8 md:!max-w-7xl md:!flex-row md:!justify-around"
        >
          {#if isAppActive}
            <div class="w-[100%] self-start md:w-[35%]">
              <SideBar />
            </div>
            <div class="flex w-[100%] flex-1 md:w-[65%]">

              <Route path="/step/1">
                <ServiceInvoice />
              </Route>
              <Route path="/step/2" component={PurchaseInformation} />
              <Route path="/step/3" component={PersonalInformation} />
              <Route path="/step/4" component={Questions} />
              <Route path="/step/5" component={TermsAndPrivacy} />
            </div>
          {:else if isStartingInFuture}
            <RegistrationNotYetStarted />
          {:else}
            <RegistrationIsOver />
          {/if}
        </div>
      </main>
      <footer class="fixed bottom-0 hidden w-full bg-black sm:block">
        <Footer {isStartingInFuture} />
      </footer>
    </div>
  {/if}
</Router>

<Errorboundery />
